"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaceForRewardsPlayers = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faChevronDown_1 = require("@fortawesome/pro-regular-svg-icons/faChevronDown");
const faPlay_1 = require("@fortawesome/pro-regular-svg-icons/faPlay");
const RaceForRewardsCreator_1 = require("root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsCreator");
const useResolutionBreakpointsMap_1 = require("root/src/client/v2/browser/hooks/useResolutionBreakpointsMap");
const useRaceForRewrardsPlayers_1 = require("root/src/client/v2/drop/features/RaceForRewards/hooks/useRaceForRewrardsPlayers");
const useRaceForRewrardsPlayer_1 = require("root/src/client/v2/drop/features/RaceForRewards/hooks/useRaceForRewrardsPlayer");
const helpers_1 = require("root/src/client/v2/drop/features/RaceForRewards/helpers");
const react_player_1 = __importDefault(require("react-player"));
const RaceForRewardsPlayers = ({ media }) => {
    const { displayedMedia, onShowMoreClick, isAutoplay, displayShowMore, } = (0, useRaceForRewrardsPlayers_1.useRaceForRewardsPlayers)(media);
    return (<div className="my-6">
			<div className="grid grid-cols-1 gap-6 lg:grid-cols-2 2xl:grid-cols-3 place-items-center">
				{displayedMedia.map((mediaItem, idx) => (<Player mediaItem={mediaItem} autoplay={isAutoplay(idx)} muted={isAutoplay(idx)} key={mediaItem.url}/>))}
			</div>
			{displayShowMore && (<ShowMore showMore={onShowMoreClick}/>)}
		</div>);
};
exports.RaceForRewardsPlayers = RaceForRewardsPlayers;
const Player = ({ mediaItem, autoplay, muted }) => {
    const { resolutionBreakpointsMap } = (0, useResolutionBreakpointsMap_1.useResolutionBreakpointsMap)();
    const { played, onPlayClick } = (0, useRaceForRewrardsPlayer_1.useRaceForRewardsPlayer)(autoplay);
    return (<div>
			{played ? (mediaItem.isStream
            ? (
            // @ts-ignore
            <react_player_1.default url={mediaItem.url} playing controls muted={muted} width={resolutionBreakpointsMap.xs ? 300 : 480}/>)
            : (<iframe title={mediaItem.creator.displayName} src={(0, helpers_1.getEmbedUrl)(mediaItem.url, muted)} width={`${resolutionBreakpointsMap.xs ? 300 : 480}px`} height={`${resolutionBreakpointsMap.xs ? 225 : 360}px`} allowFullScreen/>)) : <Thumbnail thumbnail={mediaItem.thumbnail} onClick={onPlayClick}/>}
			<RaceForRewardsCreator_1.RaceForRewardsCreator creator={mediaItem.creator}/>
		</div>);
};
const Thumbnail = ({ thumbnail, onClick }) => {
    const { resolutionBreakpointsMap } = (0, useResolutionBreakpointsMap_1.useResolutionBreakpointsMap)();
    return (<div onClick={onClick} style={{
            backgroundImage: `url(${thumbnail
                .replace('{width}', '480')
                .replace('{height}', '300')})`,
        }} className="w-[300px] h-[225px] sm:w-[480px] sm:h-[360px] relative rounded-md cursor-pointer bg-cover bg-center">
			<react_fontawesome_1.FontAwesomeIcon icon={faPlay_1.faPlay} size={resolutionBreakpointsMap.xs ? '2x' : '4x'} className="absolute inset-0 m-auto"/>
		</div>);
};
const ShowMore = ({ showMore }) => {
    return (<div onClick={showMore} className="flex flex-row items-center cursor-pointer">
			<Line />
			<div className="w-[200px] flex flex-initial items-center justify-center">
				<span className="text-teal mr-3">Show more</span>
				<react_fontawesome_1.FontAwesomeIcon className="*:text-teal" icon={faChevronDown_1.faChevronDown} size="lg"/>
			</div>
			<Line />
		</div>);
};
const Line = () => {
    return (<div className="w-3/5 h-[1px] bg-white"/>);
};
